import React from 'react';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';

export default function MainButton(props) {
  const { children } = props;

  return (
    <Button variant="contained" color="secondary" {...props}>
      {children}
    </Button>
  );
}

MainButton.propTypes = {
  children: PropTypes.node.isRequired,
};
